import { render, staticRenderFns } from "./socsosubEdit.vue?vue&type=template&id=ee75cdaa"
import script from "./socsosubEdit.vue?vue&type=script&lang=js"
export * from "./socsosubEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports